import { EventCreatorMap } from '@app/analytics/models/helpers';
import EventClickCommission from './commission-click';
import * as CommissionActions from '@app/landings/store/actions/commission.action';

const eventsMap: EventCreatorMap = {
  [CommissionActions.COMMISSION_CLICK_SELL_BUTTON]: EventClickCommission
};

export default eventsMap;
